(function() {
  function initHoverMenus() {
    if (window.innerWidth < 990) return;

    const menuItems = document.querySelectorAll('.header__inline-menu details');

    menuItems.forEach(function(details) {
      details._closeTimer = null;

      details.addEventListener('mouseenter', function() {
        clearTimeout(details._closeTimer);

        menuItems.forEach(function(other) {
          if (
            other !== details &&
            other.hasAttribute('open') &&
            !other.contains(details) &&
            !details.contains(other)
          ) {
            other.removeAttribute('open');
          }
        });
        details.setAttribute('open', '');

        let ancestor = details.parentElement && details.parentElement.closest('details');
        while (ancestor) {
          clearTimeout(ancestor._closeTimer);
          ancestor.setAttribute('open', '');
          ancestor = ancestor.parentElement && ancestor.parentElement.closest('details');
        }
      });

      details.addEventListener('mouseleave', function() {
        details._closeTimer = setTimeout(function() {
          details.removeAttribute('open');
        }, 150);
      });

      const submenu = details.querySelector(':scope > .header__submenu');
      if (submenu) {
        submenu.addEventListener('mouseenter', function() {
          clearTimeout(details._closeTimer);
        });
        submenu.addEventListener('mouseleave', function() {
          details._closeTimer = setTimeout(function() {
            details.removeAttribute('open');
          }, 150);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMenus);
  } else {
    initHoverMenus();
  }

  window.addEventListener('resize', initHoverMenus);
})();